// extracted by mini-css-extract-plugin
export var modalFooter = "_kb-0";